/*!
 * Copyright © 2018. Verizon Connect Ireland Limited. All rights reserved.
 */

export enum EReportTypeId {
  Daily = 85,
  Detailed = 47
}
